import isNum from '../utilities/isNum.js';

export default function splitArrayKey(key: string): { key: string; idx?: number } {
  const parts = key.split('.');
  const lastPart = parts.at(-1);
  if (!isNum(lastPart)) return { key };
  return { key: parts.slice(0, -1).join('.'), idx: Number.parseInt(lastPart) };
}
